import loadable from '@loadable/component';
import React from 'react';
import { Redirect as RedirectImpl } from 'react-router-dom';
import createRouteMap from '../utils/createRouteMap';
import Loading from './components/Loader';
import App from './containers/App';
import Articles from './pages/Articles/Route';
import Article from './pages/Articles/SingleArticle/Route';
import Topic from './pages/Articles/Topic/Route';
import Topics from './pages/Articles/Topics/Route';
import Feed from './pages/Feed/route';
import Find from './pages/Find/route';
import GetQuotesCampaign from './pages/GetQuotesCampaign/route';
import GetQuotesProjects from './pages/GetQuotesProjects/route';
import GetQuotesSimple from './pages/GetQuotesSimple/route';
import Homepage from './pages/Homepage/Route';
import HowItWorks from './pages/HowItWorks/route';
import ShareableVoucherActivate from './routes/Activate';
import BunningsGetQuotes from './routes/BunningsGetQuotes';
import BunningsLanding from './routes/BunningsLanding';
import BunningsOnboarding from './routes/BunningsOnboarding';
import Connect from './routes/Connect';
import DefaultPage from './routes/DefaultPage';
import Directory from './routes/Directory';
import Enquire from './routes/Enquire';
import Feedback from './routes/Feedback';
import GetQuotesBunningsCategory from './routes/GetQuotesBunningsCategory';
import JobSuccess from './routes/JobSuccess';
import VoucherActivate from './routes/LoginedActivate';
import LoginGate from './routes/LoginGate';
import Messages from './routes/Messages';
import OnDemandTradie from './routes/OnDemandTradie';
import Page from './routes/Page';
import PayModal from './routes/PayModal';
import ReceiptModal from './routes/ReceiptModal';
import SetPasswordPage from './routes/SetPassword';
import SimilarBusinesses from './routes/SimilarBusinesses';
import Thread from './routes/Thread';
import TradieView from './routes/TradieView';
import VerifyEmail from './routes/VerifyEmail';
import VoucherOffer from './routes/VoucherOffer';
import DoeGate from './routes/DoeGate';
import UploadPage from './pages/Doe/upload/UploadPage';
import { AssessmentsPage } from './pages/Doe/assessments/AssessmentsPage';

const Usage = loadable(() => import('./pages/TradiePortal/Usage'), { fallback: Loading });
const ProfileNoMatch = loadable(() => import('./containers/ProfileNoMatch'), { fallback: Loading });
const SearchBarLayout = loadable(() => import('./containers/SearchBarLayout'), {
  fallback: Loading,
});
const StandardLayout = loadable(() => import('./containers/StandardLayout'), { fallback: Loading });
const TradePortalLayout = loadable(() => import('./pages/TradiePortal/Layout'), {
  fallback: Loading,
});

const redirectTo = to => {
  return function RouteRedirect() {
    return <RedirectImpl to={to} />;
  };
};

const routes = createRouteMap([
  {
    path: '/',
    component: App,
    routes: [
      {
        path: '/',
        component: Homepage,
        exact: true,
      },
      {
        path: '/get_quotes_ppc',
        component: GetQuotesCampaign, //shall move to standard layout
      },
      {
        path: '/find/:category/get_quotes_ppc',
        component: GetQuotesCampaign,
      },
      {
        path: '/find/(.*?)/get_quotes_bunnings',
        component: GetQuotesBunningsCategory,
      },
      {
        path: '/connect',
        component: SearchBarLayout,
        routes: [
          {
            path: '/:site',
            component: Connect,
            routes: [
              { path: '/', component: DefaultPage, exact: true },
              { path: '/:type/:id/:other/:another/:more', component: ProfileNoMatch },
              { path: '/:type/:id/:other/:another', component: ProfileNoMatch },
              { path: '/:type/:id/:other', component: ProfileNoMatch },
              {
                path: '/:type/:id?',
                component: Page,
              },
            ],
          },
        ],
      },
      {
        path: '/',
        component: StandardLayout,
        routes: [
          {
            path: '/articles/page/:page',
            component: Articles,
          },
          {
            path: '/articles',
            component: Articles,
          },
          {
            path: '/article/:key',
            component: Article,
          },
          {
            path: '/activate',
            component: ShareableVoucherActivate,
          },
          {
            path: '/how-it-works',
            component: HowItWorks,
          },
          {
            path: '/bunnings_onboarding',
            component: BunningsOnboarding,
          },
          {
            path: '/bunnings_landing',
            component: BunningsLanding,
          },
          { path: '/c/:letter([a-z])', component: Topics },
          { path: '/c/:topic/page/:page', component: Topic },
          { path: '/c/:topic', component: Topic },
          { path: '/c', component: Topics },
          {
            path: '/odte',
            component: OnDemandTradie,
          },
          {
            path: '/bunnings_get_quotes',
            component: BunningsGetQuotes,
          },
          {
            path: '/change',
            component: redirectTo('/'),
          },
          {
            path: '/directory',
            component: Directory,
          },
          {
            path: '/enquire/:site',
            component: Enquire,
            props: {
              buttonText: 'Send an Enquiry',
              title: 'Send an enquiry to',
              tileTitle: 'We will send your enquiry to',
              basePath: 'enquire',
              enableJobsCheckbox: true,
            },
            routes: [
              {
                path: '/similar_businesses/:job_id',
                component: SimilarBusinesses,
              },
            ],
          },
          {
            path: '/find/:category/get_quotes_projects',
            component: GetQuotesProjects,
          },
          {
            path: '/get_quotes_projects',
            component: GetQuotesProjects,
          },
          {
            path: '/find/:category/get_quotes_simple',
            component: GetQuotesSimple,
          },
          {
            path: '/find',
            component: Find,
          },
          {
            path: '/request_quote/:site',
            component: Enquire,
            routes: [
              {
                path: '/similar_businesses/:job_id',
                component: SimilarBusinesses,
              },
            ],
            props: {
              buttonText: 'Request a quote',
              title: 'Request a quote from',
              tileTitle: 'We will send your request to',
              basePath: 'request_quote',
              enableJobsCheckbox: true,
            },
          },
          {
            path: '/job',
            component: LoginGate,
            routes: [
              {
                path: '/:job/feedback_app/:assignment',
                component: Feedback,
              },
              {
                path: '/:job/feedback/:assignment',
                component: Feedback,
              },
            ],
          },
          {
            path: '/account',
            component: LoginGate,
            routes: [
              { path: '/feed/:filter?/:subfilter?', component: Feed },
              {
                path: '/voucher-offer',
                component: VoucherOffer,
              },
              {
                path: '/job/:job/leave-feedback',
                component: Feedback,
              },
              {
                path: '/voucher-activate/:id',
                component: VoucherActivate,
              },
              {
                path: '/job/:job/interested-businesses',

                component: JobSuccess,
                routes: [
                  {
                    path: '/:assignment',
                    component: TradieView,
                    routes: [
                      {
                        path: '/pay/:uuid?',
                        component: PayModal,
                      },
                      {
                        path: '/receipt',
                        component: ReceiptModal,
                      },
                      {
                        path: '/hire',
                        component: loadable(
                          () => import('./pages/JobSuccess/TradieConversation/Hire'),
                          { fallback: Loading }
                        ),
                      },
                    ],
                  },
                ],
              },
              {
                path: '/message_centre',
                component: LoginGate,
                routes: [
                  {
                    path: '/',
                    component: Messages,
                    routes: [
                      {
                        path: '/:group',
                        component: Thread,
                      },
                    ],
                  },
                ],
              },
              {
                path: '/',
                component: TradePortalLayout,
                routes: [
                  {
                    path: '/usagev4',
                    component: Usage,
                  },
                ],
              },
            ],
          },
          {
            path: '/verify',
            component: LoginGate,
            routes: [
              {
                path: '/',
                component: VerifyEmail,
              },
            ],
          },
          {
            path: '/reset-password',
            component: LoginGate,
            routes: [
              {
                path: '/',
                component: SetPasswordPage,
              },
            ],
          },
          {
            path: '/get_quotes_simple',
            component: GetQuotesSimple, //shall move to standard layout
          },
          {
            path: 'doe',
            component: DoeGate,
            routes: [
              {
                path: '/upload',
                component: UploadPage,
              },
              {
                path: '/assessments',
                component: AssessmentsPage,
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default routes;
